import React from "react";
import { stockListFormatter } from "../../../../utils/stockList.utils";
import { arrayMap } from "../../../../utils/array.utils";
import VehicleCustomerRequirementView from "./VehicleCustomerRequirementView";
import Button from "../../../../ui/Button";

export default function VehicleCustomerRequirements({ data, loading, children }) {
  const formattedData = stockListFormatter(data);
  const money_receipts = formattedData?.money_receipts ?? [];
  const mrLength = money_receipts?.length ?? 0;
  return (
    <div>
      {mrLength > 1 ? (
        <div className="d-flex flex-wrap align-items-center ">
          {children} &nbsp;&nbsp; <Button name={mrLength} />
        </div>
      ) : (
        children
      )}
      <div className="row mt-0 g-3">
        {arrayMap(money_receipts, (item, index) => (
          <div className="col-12" key={item?.id}>
            <VehicleCustomerRequirementView data={item} cardIndex={index + 1} />
          </div>
        )) || (
          <p className="text-center">
            This car is still available and has not been booked by a customer.
          </p>
        )}
      </div>
    </div>
  );
}
